import * as React from "react";

const SvgVibe = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 24"
    fill="none"
    width="1em"
    height="1em"
    {...{ ...props, ref }}
  >
    <defs>
      <linearGradient
        id="vibe_gradient"
        x1="13.4997"
        y1="0"
        x2="13.4997"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3730A3" />
        <stop offset="1" stopColor="#4F46E5" />
      </linearGradient>
      <clipPath id="vibe_clip">
        <rect width="27" height="24" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#vibe_clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4726 14.6154C23.4492 14.6574 26.7559 11.5408 26.8996 7.57042C27.0455 3.53699 23.872 0.149744 19.8113 0.00480693C16.6702 -0.10734 13.9183 1.75349 12.7655 4.46897L11.8384 3.0723C9.89275 0.141289 5.92341 -0.668075 2.97258 1.26452C0.0217745 3.19711 -0.793067 7.13981 1.15258 10.0708L8.5016 21.1417C10.4473 24.0727 14.4166 24.8821 17.3674 22.9495C20.1624 21.1189 21.041 17.4849 19.4726 14.6154ZM22.9488 7.44119C22.8815 9.30078 21.3093 10.7541 19.4371 10.6873C17.565 10.6204 16.1018 9.05876 16.1691 7.19917C16.2364 5.33954 17.8086 3.88622 19.6808 3.95309C21.553 4.01991 23.0161 5.5816 22.9488 7.44119ZM5.25216 4.60318C6.35183 3.88296 7.83109 4.18459 8.55617 5.27688L15.8935 16.3301C16.6186 17.4224 16.3149 18.8917 15.2152 19.6119C14.1156 20.3322 12.6363 20.0305 11.9112 18.9383L4.57391 7.88497C3.84882 6.79268 4.1525 5.32336 5.25216 4.60318Z"
        fill="url(#vibe_gradient)"
        className="print:fill-[#3730A3]"
      />
    </g>
  </svg>
);

export default React.forwardRef(SvgVibe);
